<template>
    <div>
        <!-- 大统华供应链人员登陆中 -->
        <!--
        <p> ticket:{{ticket}} </p>
        <p> destinationRoute:{{destinationRoute}} </p>
        -->
        <div class="img_wrap">
            <p><img class="" :src="loading"/></p>
        </div>
        
    </div>
</template>

<script>

import loadingGif from '@/assets/images/loading.gif';
import {findRouteByRouteName} from "../../router/index";
import AuthApi from "../../api/smp/auth/Auth.js";
import AuthUtil from "../../util/auth.js";

export default{
		name:"Oa-Link-Login",
		data(){
		    return {
                loading:loadingGif,
                oaTicket:"",
                destinationRoute:"",
                accessToken:""
		    }
		},
		created:function(){
            console.log('oa link login created');
            this.login();
        },
        mounted:function(){
            console.log('oa link login mountted');
            //this.$router.push({name: "sm-provider-return-order-confirm",params:{page:{id:'341'}}});	
        },
		methods:{
            async login(){
                let me = this;

                this.oaTicket = this.$route.query.tokenId;
                this.destinationRoute = 'desktop';
                 
                //console.log(this.sm_provider_ticket+"-"+this.destinationRoute);
                if(!this.oaTicket || ! this.destinationRoute){
                    this.$router.push({name: '500',params:{page:{id:-1}}});	
                    return ;
                }

                let route = findRouteByRouteName(me.destinationRoute);
                if(!route){
                    this.$router.push({name: '500',params:{message:'未找到路径'}});	
                    return;
                }
                
                try{
                    let accessToken  = await this.oaTicketLogin(this.oaTicket);
                    if(accessToken){
                      AuthUtil.setAccessToken(accessToken);
                      this.$router.push({name: me.destinationRoute});	
                    }
                }catch(err){
                    console.log(err.message);
                    me.errMsg('错误',err.message);
                    return ;
                }

                //console.log("routeing to destination:"+me.destinationRoute);
                //console.log(route.meta.page);
                
            },
            async oaTicketLogin(ticket){
                console.log("ticket:"+ticket+" 开始登录");
                let resp = await AuthApi.oaLinkLogin(ticket);
    
                console.log("ticket login response:");
                console.log(resp);
                let data = resp.data;
                if((!data)||(!(data.code))||(data.code!=200)){
                    let msg=data.msg_detail;
                    msg = ((!msg)||(msg==''))?'获取令牌失败':msg;
                    throw new Error(msg);
                }
                if((!data.data.tokenInfo)||(!data.data.tokenInfo.access_token)||(data.data.tokenInfo.access_token=='')){
                    throw new Error('获取令牌失败(无令牌数据)');
                }
                let accessToken = data.data.tokenInfo.access_token;
                
                return accessToken;	
            },

            async  errMsg(title,text){
            await this.$dialog.error({
                text: text,
                title: title
            }); 
		},
        },
        
        
}

</script>

<style scoped>

.img_wrap{
    position:absolute;
    left:50%;
    margin-left:-150px;

}

</style>